import "../../../../assets/presentation/components/controls/button/button-icon-BMZbOHNb.css";
/* empty css            */
import classNames from "classnames";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/button/button-icon.tsx
var ButtonIcon = ({ className, testId, children }) => /* @__PURE__ */ jsx("span", {
	className: classNames("button-icon", className),
	"data-testid": testId,
	children
});
//#endregion
export { ButtonIcon };

//# sourceMappingURL=button-icon2.js.map